module.exports = __webpack_public_path__ + "media/emissao_encomendas.cebb2ebd.mp4";